import { FAILURE, SUCCESS } from "../../constants/BaseConstants";
import { GET_TOKEN, LOGOUT, SET_EMAIL, SET_PASSWORD } from "../../constants/ClientConstants";

const initialState: ClientStateType = {
    email: "",
    password: "",
    isLoading: false,
    user: {
        ID: 0,
        caps: {},
        displayName: "",
        roles: [],
        token: "",
        userEmail: "",
        userLogin: "",
        userNicename: "",
        userRegistred: "",
        userStatus: "",
        userUrl: ""
    }
};

export default (state = initialState, action: any) => {
    switch (action.type) {
        case SET_EMAIL:
            return {
                ...state,
                email: action.email
            };
        case SET_PASSWORD:
            return {
                ...state,
                password: action.password
            };
        case GET_TOKEN:
            return {
                ...state,
                isLoading: true
            };
        case GET_TOKEN + FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case GET_TOKEN + SUCCESS:
            return {
                ...state,
                isLoading: false,
                email: "",
                password: "",
                user: action.user
            };
        case LOGOUT:
            return {
                ...state,
                user: initialState.user
            };
        default:
            return state;
    }
};
